<template>
  <div class="CarryOnBaggageText container_w dis_bo" style="padding-top: 96px;">
    <div v-html="collapseHtml"></div>
  </div>
</template>

<script>
export default {
  name: "CarryOnBaggage",
  data() {
    return {
      fileTitle: "",
      collapseHtml: ''
    };
  },
  props: {},
  watch: {},
  methods: {
    getFileTextHtml(url) {
      this.$Ajax.get(url).then((response) => {
        this.collapseHtml = response.data
      }).catch((error) => {
        console.log(error);
      });
    },
  },
  filters: {},
  computed: {},
  created() {
    this.getFileTextHtml("/Html/Content/99b08f24f36e41dbabfd2fff4ad0abea.html")
  },
  mounted() {},
  destroyed() {}
};
</script>

<style scoped lang="less">

</style>